
























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import { FindAnalyticsUseCase } from '@/usecases'
import type { LojaServiceAdapter, MarketplaceServiceAdapter, ThreadsServiceAdapter } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import axios, { CancelTokenSource } from 'axios'
import { DataOptions } from 'vuetify'
import { Loja } from '@/models'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import ImagemDeTabela from '@/components/ui/ImagemDeTabela.vue'
@Component({
	components: {
		SeletorDeLojas,
		DataTableDeCrud,
		ImagemDeTabela,
	},
})
export default class TelaDePedidosMarketplace extends Vue {
	carregandoDadosMarketplace = false
	erro: null | Error = null
	findAnalyticsUseCase = new FindAnalyticsUseCase()
	filtroDeLojas: any[] = []
	aplicouFiltroInicial = false
	cancelToken: CancelTokenSource | null = null
	pedidosMarketplace: any[] | null = []
	dadosDaLojaCarregada = false
	iniciandoSincronizacao = false
	lojaSelecionada: Loja | null = null
	executandoProcessoPedidos = false
	intervalId: number | null = null

	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	totalRegistros = 0

	headers = [
		{ text: 'Marketplace', value: 'canalVenda' },
		{ text: 'Identificador Almode', value: 'identificadorInterno' },
		{ text: 'Identificador Marketplace', value: 'identificadorMarketplace'},
		{ text: 'Erro', value: 'mensagemErro'},
		{ text: 'Status', value: 'status'},
	]

	@Inject('LojaServiceAdapter')
	lojaService!: LojaServiceAdapter

	@Inject('MarketplaceServiceAdapter')
	marketplaceService!: MarketplaceServiceAdapter

	@Inject('ThreadsServiceAdapter')
	threadsService!: ThreadsServiceAdapter

	mounted() {
		this.intervalId = setInterval(async () => {
			try {
				await this.recarregarStatusProcesso()
			} catch (error) {
				AlertModule.setError('Falha ao verificar andamento do processo de pedidos')
			}
		}, 10000) as unknown as number
	}

	destroyed() {
		if (this.intervalId) {
			clearInterval(this.intervalId)
			this.intervalId = null
		}
	}

	statusFormatado(status: string) {
		let statusFormatado = ''
		switch(status) {
			case 'NEW':
				statusFormatado = 'Novo'
				break
			case 'SHIPPED':
				statusFormatado = 'Enviado'
				break
			case 'CREATED':
				statusFormatado = 'Criado'
				break
			case 'APPROVED':
				statusFormatado = 'Aprovado'
				break
			case 'INVOICED':
				statusFormatado = 'Faturado'
				break
			case 'CANCELED':
				statusFormatado = 'Cancelado'
				break
			case 'COMPLETED':
				statusFormatado = 'Completo'
				break
			default:
				statusFormatado = 'Sem status'
		}

		return statusFormatado
	}

	formataNomeDaLojaChip(nome: string) {
		const nomeSplitado = nome.match(/[a-zA-Z]{4,}/g)
		if (!nomeSplitado) return nome
		return nomeSplitado.map(nome => nome.substr(0, 4)).join('.')
	}

	remove(item) {
		const index = this.filtroDeLojas.findIndex(loja => loja === item.id);
		if (index !== -1) {
			this.filtroDeLojas.splice(index, 1);
		} else {
			this.filtroDeLojas = [];
		}
	}

	@Watch('filtroDeLojas')
	async aplicarFiltro() {
		this.carregandoDadosMarketplace = true
		try {
			if (!this.filtroDeLojas) {
				this.dadosDaLojaCarregada = false
				this.carregandoDadosMarketplace = false
				return
			}

			if (typeof this.filtroDeLojas === 'string') {
				this.cancelToken = axios.CancelToken.source()
				const params = {
					page: this.paginacao.page - 1,
					size: this.paginacao.itemsPerPage,				
				}
				
				const axiosConfig = {
					cancelToken: this.cancelToken.token,
				}
				
				const page = await this.marketplaceService.findAllPedidos(this.filtroDeLojas, params, axiosConfig)
				this.totalRegistros = page.totalElements
				this.pedidosMarketplace = page.content
				this.dadosDaLojaCarregada = true
				this.lojaSelecionada = await this.lojaService.get(this.filtroDeLojas)
			} else {
				this.dadosDaLojaCarregada = false
			}

		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.carregandoDadosMarketplace = false
		}
	}

	async aplicarFiltroSemLoading() {
		try {
			if (typeof this.filtroDeLojas === 'string') {
				this.cancelToken = axios.CancelToken.source()
				const params = {
					page: this.paginacao.page - 1,
					size: this.paginacao.itemsPerPage,				
				}
				const axiosConfig = {
					cancelToken: this.cancelToken.token,
				}
				const page = await this.marketplaceService.findAllPedidos(this.filtroDeLojas, params, axiosConfig)
				this.totalRegistros = page.totalElements
				this.pedidosMarketplace = page.content
				this.lojaSelecionada = await this.lojaService.get(this.filtroDeLojas)
			}
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	async recarregarStatusProcesso() {
		if (!this.lojaSelecionada) return

		this.cancelToken = axios.CancelToken.source()
		const params = {
			nomeThread: 'AsyncThread-IntegrarPedidosPlug4marketPorLoja-'+this.lojaSelecionada.id,
		}
		
		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}

		const threads = await this.threadsService.findAll(params, axiosConfig)

		if (threads.length > 0) {
			this.executandoProcessoPedidos = threads.map(thread => thread.state).includes('RUNNABLE')
		} else {
			this.executandoProcessoPedidos = false
		}

		if (!this.executandoProcessoPedidos) this.aplicarFiltroSemLoading()
	}

	async integrarPedidos() {
		if(!this.lojaSelecionada) return

		try {
			this.iniciandoSincronizacao = true
			await this.marketplaceService.integrarPedidos(this.lojaSelecionada.id)
			await this.recarregarStatusProcesso()
			AlertModule.setSuccess('Sincronização iniciada')
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.iniciandoSincronizacao = false
		}
	}

	async recarregar() {
		await this.aplicarFiltro()
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao() {
		this.aplicarFiltro()
	}
}
